export default "__VITE_ASSET__cb08d78c__"